import { render, staticRenderFns } from "./EditProfileDialog.vue?vue&type=template&id=047ab2c9&scoped=true"
import script from "./EditProfileDialog.vue?vue&type=script&lang=js"
export * from "./EditProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./EditProfileDialog.vue?vue&type=style&index=0&id=047ab2c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047ab2c9",
  null
  
)

export default component.exports